module.exports = __webpack_public_path__ + "static/media/safari.d201899b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/safari.png
// module id = 411
// module chunks = 1